export default {
    ren: '人',
    jiangong: '件，合計',
    dingdanjine: 'オーダー金額',
    bubaohandandu: 'この金額には、個別に購入したセカンダリ製品の金額は含まれません',
    shijizhifu: '実際の支払い',
    yincangquanbu: 'すべてを隠す',
    zhankaiquanbu: 'すべて展開',
    dingdanxiangqing: '注文の詳細',
    yizhifu: '支払い済み',
    caozuo: '操作',
    dingdanchuangjianshijian: 'オーダー作成日',
    ewaixingli: '余分な荷物を購入する',
    tianjiaxingli: '荷物サービスの追加',
    zanweigoumaifuyingchanpin: "セカンダリ製品はまだ購入されていません",
    xinglixinxi: '荷物情報',
    buxuyao: '必要ありません',
    suoyouchengke: 'すべての乗客',
    weisuoyouchengkegoumai: 'すべての乗客に一括購入',
    weisuoyouchengkedandugoumai: '乗客ごとに個別に購入',
    qucheng: 'トリップ',
    huicheng: 'リターンマッチ',
    fujiafuwu: 'オプション',
    xinglizonge: '荷物の総額'
};